import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { BRAND_CATALYST_PREFERENCE_REPORTER_BLOCK_MSG,
  BRAND_CATALYST_PREFERENCE_REPORTER_AUTO_UPDATE_LABEL,
} from '../../constants';

class PreferencesAutoUpdateCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.field.defaultValue,
    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.userPreferences) &&
      nextProps.userPreferences !== this.props.userPreferences) {
      const keys = this.props.field.dbKey.split('.');
      this.setState({ isChecked: nextProps.userPreferences[keys[0]][keys[1]] });
    }
    if (nextProps.cancelAutoUpdateFlag && this.props.userPreferences) {
      this.onValueChange();
      this.props.toggleCancelFlag();
    }
  }

  onValueChange = () => {
    this.setState((prevState) => ({
      isChecked: !prevState.isChecked,
    }), () => this.props.updatePreferences(this.props.field.dbKey, this.state.isChecked));
  }

  render() {
    const { field } = this.props;
    const { isChecked } = this.state;
    return (
      <div>
        {field.dbKey === '_bc._aus' &&
          <div className="column big-label-width-bc-reporter">
            <div style={{ width: '100%', padding: '15px' }}>
            {BRAND_CATALYST_PREFERENCE_REPORTER_AUTO_UPDATE_LABEL} </div>
          </div>
          }
        {field.dbKey !== '_bc._aus' &&
          <div className="column big-label-width">
            <div style={{ width: '100%', padding: '15px' }}>Auto update: </div>
          </div>
          }
        {/* </div> */}
        <div className="column big-content-width">
          <div className="custom-preference">
            <div className="custom-preference-content">
              <input id={field.dbKey} type="checkbox" onChange={() => this.onValueChange()} checked={isChecked} />
              <label htmlFor={field.dbKey}>{field.inputLabel}</label>
            </div>
          </div>
        </div>
        {
          isChecked && field.dbKey === '!_bc._aus'
            ? <div className="column auto-update-label-width">
            Your default study will automatically update to the most recent study released </div>
            : null
        }
        {
          isChecked && field.dbKey === '_bc._aus'
            ? <div className="column auto-update-label-width">
              {BRAND_CATALYST_PREFERENCE_REPORTER_BLOCK_MSG} </div>
            : null
        }
      </div>
    );
  }
}

PreferencesAutoUpdateCheckbox.propTypes = {
  // studies: PropTypes.arrayOf(PropTypes.shape({})),
  toggleCancelFlag: PropTypes.func,
  field: PropTypes.shape({
    defaultValue: PropTypes.bool,
    dbKey: PropTypes.string,
    inputLabel: PropTypes.bool,
  }),
  modifiedPreferences: PropTypes.shape({
    _ct: PropTypes.shape({
      _ds: PropTypes.string,
    }),
  }),
  updatePreferences: PropTypes.func,
  userPreferences: PropTypes.shape({}),
  cancelAutoUpdateFlag:PropTypes.bool
};

function mapStateToProps(state) {
  return {
    studies: state.study.studies,
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    userPreferences: state.preferences.userPreferences,
    lastLocation: state.preferences.lastLocation,
  };
}

export default connect(mapStateToProps)(PreferencesAutoUpdateCheckbox);

